import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { CartDeleteComponent } from './cart-delete.component';
import { DeleteCartModalComponent } from './delete-cart-modal/delete-cart-modal.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    I18nModule,
    RouterModule,
    UrlModule,
    CartDeleteComponent,
    DeleteCartModalComponent,
  ],
  exports: [CartDeleteComponent, DeleteCartModalComponent],
  providers: [
    provideConfig({
      ...LaunchDialogModalLayoutConfig.Carts,
    }),
  ],
})
export class CartDeleteModule {}
